/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import FormGroup from '@mui/material/FormGroup';
import { InputLabel, DataLine } from 'components/elements';
import CheckboxesGroup from './CheckboxesGroup';

function CheckboxesGroupControl({ isEditMode, name, control, labelText, label, rules, options, optionClasses }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { ref, value, ...restField }, fieldState: { error } }) =>
        isEditMode ? (
          <CheckboxesGroup
            options={options}
            error={!!error}
            helperText={error ? error.message : null}
            optionClasses={optionClasses}
            label={label || <InputLabel text={labelText} />}
            value={value}
            {...restField}
          />
        ) : (
          <DataLine
            label={labelText}
            body={options
              .filter(({ value: optionValue }) => value.includes(optionValue))
              .map(({ label: optionLabel }) => optionLabel)
              .join(', ')}
          />
        )
      }
    />
  );
}

CheckboxesGroupControl.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.element,
  onChange: PropTypes.func,
  column: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.any),
  optionClasses: PropTypes.string,
  ...FormGroup.propTypes,
};

CheckboxesGroupControl.defaultProps = {
  children: null,
  column: false,
  value: [],
  label: null,
  options: [],
  onChange: () => {},
  optionClasses: '',
};

export default CheckboxesGroupControl;
